import mixpanel from "mixpanel-browser";

export function trackEvent(eventName) {
    try {
        window.gtag("event", eventName, {
            event_category: "editor",
            event_label: eventName,
        });
        window.fbq("track", eventName, {
            content_name: "editor",
        });
    } catch (e) {
        console.log(e);
    }
}

export function identifyUser(phone) {
    try {
        mixpanel.identify(phone);

        mixpanel.people.set({
            "$phone": phone
        });
    } catch (e) {
        console.log(e);
    }
}

export function trackMixEvent(eventName, subEvent, bookId) {
    try {
        mixpanel.track(eventName, {
            "subEvent": subEvent,
            "bookId": bookId
        });
    } catch (e) {
        console.log(e);
    }
}
